import { useState } from "react"

import { useTranslation } from "@bounce/i18n"
import { resolveStoreTypeIcon } from "@bounce/store"
import { PNImage } from "@bounce/web-components"

import { StoreCardOpenStatus } from "./StoreCardOpenStatus"
import { StoreCardTag } from "./StoreCardTag"
import { getStoreThumbnail } from "@/libs/bounce/stores/getStoreThumbnail"
import type { NearbyStorageSpot } from "@/libs/bounce/stores/types"

import RocketIcon from "@bounce/assets/icons/Rocket.svg"

type StoreCardImageProps = {
  store: NearbyStorageSpot
  nickname: string
  popular?: boolean
}

export const StoreCardImage = ({ store, nickname, popular = false }: StoreCardImageProps) => {
  const { t } = useTranslation()
  const [thumbnailError, setThumbnailError] = useState(false)
  const href = getStoreThumbnail(store)

  const StoreTypeIcon = resolveStoreTypeIcon(store.type)

  return (
    <div className="relative h-32 min-w-[260px] md:min-h-[260px]">
      {!!href && !thumbnailError ? (
        <PNImage
          src={href}
          alt={t("cmp.storeCard.imageAlt", "Storefront for {NICKNAME}", {
            NICKNAME: nickname,
          })}
          className="size-full rounded-xl object-cover"
          width={520}
          height={520}
          onError={() => setThumbnailError(true)}
        />
      ) : (
        <div className="pointer-events-none absolute inset-0 rounded-xl bg-lilac-100">
          <StoreTypeIcon className="absolute inset-0 m-auto size-8 text-cranberry-700 lg:size-10" />
        </div>
      )}
      <div className="absolute bottom-2 left-2 flex flex-row flex-wrap gap-2">
        <StoreCardOpenStatus store={store} />
        {popular && (
          <StoreCardTag
            bgColor="yellow"
            className="text-stone-900"
            icon={<RocketIcon className="mr-1 text-stone-900" />}
            size="small"
            text={t("cmp.storeCard.popularTagLabel", "Popular")}
          />
        )}
      </div>
    </div>
  )
}
